import React, { useState } from 'react';
import styles from './ResultPage.module.css';
import CheckList from '../components/CheckList';
import DetalhesCard from '../components/DetalhesCard';
import { gerarRelatorioPDF } from '../utils/pdfGenerator';
import logo from '../assets/logo.png';

export default function ResultPage({ resultado, onVoltar, user, onLogout, bearerToken }) {
  const r = resultado;

  const API_URL = process.env.REACT_APP_API_URL || '';

  const handleGerarPDF = () => {
    gerarRelatorioPDF(r, user);
  };


  function handleBackClick() {
    if (user?.userGuest) {

      window.location.href = '/consulta-avulsa';
    } else {

      onVoltar();
    }
  }

  return (
    <div className="history-root">

      {/* <header className={styles.header}>
        <div className={styles.logo}>
          <img
            src={logo}
            alt="Analise Central"
            className={styles.logoImage}
          />
        </div>
        {!user?.userGuest && (
          <div className={styles.accountBox}>
            <div className={styles.accountMeta}>
              <strong>{user?.empresa || 'Conta autenticada'}</strong>
              
              <span
                className={`${styles.creditInfo} ${
                  user?.creditsExpired ? styles.creditExpired : ''
                }`}
              >
                {user?.credits ?? 0} {
                  user?.creditsExpired ? 'expirados' : ' créditos'
                }
              </span>
            </div>
            <a href="/recargas" className={styles.btnRecargas}>
              Recargas
            </a>
            <a href="/historico" className={styles.btnRecargas}>
              Historico
            </a>
            <button className={styles.btnLogout} onClick={onLogout} type="button">
              Sair
            </button>
          </div>)}
      </header> */}

      <header className="history-header">
        <div className="container">
          <div className="history-header-inner">
            <a href="/" className="history-logo"><img src={logo} alt="AnaliseCentral" style={{height: '100px'}} /></a>
            {!user?.userGuest && (<nav className="history-header-nav">
              <a href="/">Inicio</a>
              <a href="/historico" >Histórico</a>
              <a href="/recargas" >Recargas</a>
            </nav>)}
            {!user?.userGuest && (<div className="history-user">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="user-name">{user?.empresa || 'Conta autenticada'}</span>
                <span
                  className={`${styles.creditInfo} ${user?.creditsExpired ? styles.creditExpired : ''
                    }`}
                >
                  {user?.credits ?? 0} {
                    user?.creditsExpired ? 'expirados' : ' créditos'
                  }
                </span>
              </div>
              <button className="btn-sair" onClick={onLogout}>Sair</button>
            </div>)}
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="history-hero">
        <div className="container">
          <span className="history-hero-label">Área do Cliente</span>
          <h1>Visualise o <span className={styles.heroAccent}>resultado</span></h1>
          <p className="history-hero-desc">
          </p>
        </div>
      </div>

      <main className={styles.main}>

        {/* Botões de ação */}
        <div className={styles.buttonsRow}>
          <button className={styles.btnPdf} onClick={handleGerarPDF}>
            📄 GERAR PDF
          </button>
          <button className={styles.btnVoltar2} onClick={handleBackClick}>
            🔄 Nova consulta →
          </button>
        </div>

        {r.tipo == 'PF' ? (
          <div className={styles.pessoaCard}>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Nome</span>
                <span className={styles.fieldVal}>{r.pessoa.nome}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>CPF</span>
                <span className={`${styles.fieldVal} ${styles.mono}`}>{r.pessoa.cpf}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Região do CPF</span>
                <span className={styles.fieldVal}>{r.sintese?.pessoa[0]?.regiao_cpf || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Idade</span>
                <span className={styles.fieldVal}>{r.pessoa.idade} anos</span>
              </div>
            </div>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Nascimento</span>
                <span className={styles.fieldVal}>{r.pessoa.dataNascimento}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Gênero</span>
                <span className={styles.fieldVal}>{r.pessoa.genero || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Mãe</span>
                <span className={styles.fieldVal}>{r.pessoa.mae || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Perfil</span>
                <span className={`${styles.fieldVal} ${styles.mosaic}`}>{r.pessoa.mosaic || '—'}</span>
              </div>
            </div>
          </div>) :
          (<div className={styles.pessoaCard}>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Razão Social</span>
                <span className={styles.fieldVal}>{r.pessoa.razaoSocial}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Fantasia</span>
                <span className={styles.fieldVal}>{r.pessoa.nomeFantasia || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>CNPJ</span>
                <span className={`${styles.fieldVal} ${styles.mono}`}>{r.pessoa.cnpj}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Capital Social</span>
                <span className={styles.fieldVal}>{r.pessoa.capitalSocial || '—'}</span>
              </div>
            </div>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Tipo</span>
                <span className={styles.fieldVal}>{r.pessoa.tipoEstabelecimento || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Natureza Jurídica</span>
                <span className={styles.fieldVal}>{r.pessoa.naturezaJuridica}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Fundação</span>
                <span className={styles.fieldVal}>{r.pessoa.dataFundacao}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Situação CNPJ</span>
                <span className={styles.fieldVal}>{r.pessoa.situacaoCnpj}</span>
              </div>
            </div>
          </div>)
        }

        <div className={styles.grid2}>
          <CheckList titulo="Pontos de atenção" items={r.alertas} tipo="alerta" />
          <CheckList titulo="Fatores positivos" items={r.positivos} tipo="positivo" />
        </div>

        <DetalhesCard detalhes={r.detalhes} sintese={r.sintese} />

        <div className={styles.footer}>
          <span>Consulta realizada em {r.dataConsulta} · Analise Central v1.0</span>
        </div>
      </main>
    </div>
  );
}